import React from 'react'
import {FormattedDate} from 'react-intl'

import {Box} from '@vio/atlas/helpers/Box'
import {Tag} from '@vio/atlas/src/components/designSystem/Tag'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

export const SplitBookingRoomTags = ({
  checkIn,
  checkOut,
  numberOfNights
}: {
  checkIn: string
  checkOut: string
  numberOfNights: number
}) => {
  return (
    <Box display="flex" gap="s200">
      <Tag variant="neutral" size="sm">
        <FormattedDate
          value={checkIn}
          day="numeric"
          month="short"
          timeZone="UTC"
        />{' '}
        -{' '}
        <FormattedDate
          value={checkOut}
          day="numeric"
          month="short"
          timeZone="UTC"
        />
      </Tag>
      <Tag variant="neutral" size="sm">
        <FormattedMessageWrapper
          id="numberOfNights"
          defaultMessage="{count, plural, one {1 night} other {# nights}}"
          values={{count: numberOfNights}}
        />
      </Tag>
    </Box>
  )
}
